export const NAME = 'leasing';

export const SET_INTEREST_CHANGED_ALLOWED = `${NAME}/SET_INTEREST_CHANGED_ALLOWED`;
export const SET_MILEAGE = `${NAME}/SET_MILEAGE`;
export const SET_MORTGAGE_ITEM = `${NAME}/SET_MORTGAGE_ITEM`;
export const SET_CAR_INSURANCE_COMPANY = `${NAME}/SET_CAR_INSURANCE_COMPANY`;
